// extracted by mini-css-extract-plugin
module.exports = {"scrollDownArrow":"ScrollingArrow_scrollDownArrow__3b-uj","fade_move_down":"ScrollingArrow_fade_move_down__H21Bg"};